// extracted by mini-css-extract-plugin
export var label = "_ct-1";
export var reminder = "_ct-0";